import { render, staticRenderFns } from "./UpdateSkill.vue?vue&type=template&id=f015f5b4"
import script from "./UpdateSkill.vue?vue&type=script&lang=js"
export * from "./UpdateSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports